import type { ThemeOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
    interface BreakpointOverrides {
        xs0: true;
        xs: true;
        sm: true;
        md: true;
        md480: true;
        md680: true;
        md920: true;
        mdLg: true;
        lg: true;
        xl: true;
    }
}

const useMuiStyles = (): ThemeOptions => {
    return {
        typography: {
            fontFamily: '"Inter", sans-serif',
            fontSize: 14,
            fontWeightRegular: 400,
            fontWeightMedium: 500,
            fontWeightBold: 700
        },
        breakpoints: {
            values: {
                xs0: 0,
                xs: 360,
                sm: 600,
                md: 840,
                md480: 480,
                md680: 680,
                md920: 920,
                mdLg: 1100,
                lg: 1440,
                xl: 1920
            }
        },
        components: {
            MuiButtonBase: {
                styleOverrides: {
                    root: {
                        fontFamily: '"Inter", sans-serif'
                    }
                }
            },
            MuiDialog: {
                defaultProps: {
                    closeAfterTransition: false
                }
            }
        }
    };
};

export { useMuiStyles };
